import type { CurrentUser } from '@cancercentrum/inca';
import { useIPO } from './useIPO.ts';

export default (): CurrentUser => {
    const { currentUser } = useIPO();

    return currentUser;
};
